import trApplicationDetails from '../fakeData/applications/application';
import enApplicationDetails from '../fakeData/applications/en-application';
import trApplicationCategories from '../fakeData/applications/applications';
import enApplicationCategories from '../fakeData/applications/en-applications';
import trMedia from '../fakeData/media/media';
import enMedia from '../fakeData/media/en-media';

const buildTwoWayMap = (pairs) => {
  const trToEn = {};
  const enToTr = {};

  pairs.forEach(([trId, enId]) => {
    trToEn[trId] = enId;
    enToTr[enId] = trId;
  });

  return { trToEn, enToTr };
};

const blogPairs = [
  ['rujlarin-yan-etkileri', 'side-effects-of-lipsticks'],
  ['gunes-yanigi', 'sunburn'],
  ['kollajen-nedir', 'what-is-collagen'],
  ['saclar-neden-beyazlar', 'why-does-hair-turn-white'],
  ['erkek-tipi-sac-dokulmesi', 'male-pattern-hair-loss'],
  ['cildiniz-icin-en-iyi-7-antidoksan', 'top-7-antioxidants-for-your-skin'],
  ['akne-sivilce-izlerinin-tedavisi', 'acne-treatment-of-acne-scars'],
  ['deri-catlaklari-neden-olur-nasil-onlerim', 'why-do-skin-stretch-marks-occur'],
  ['uyuz-nasil-bulasir-ve-korunma-yontemleri-nelerdir', 'how-does-scabies-spread-and-what-are-the-prevention-methods'],
  ['yuz-lekelerinden-kurtulmak-mumkun-mu', 'is-it-possible-to-get-rid-of-facial-blemishes'],
  ['dijital-ekranlar-cildi-yaslandiriyor', 'digital-screens-age-the-skin'],
  ['yuz-ve-boyun-genclestirmede-mezoterapi-uygulamalari', 'mesotherapy-applications-for-facial-and-neck-rejuvenation'],
  ['derin-ve-ince-kirisikliklar-nasil-tedavi-edilir', 'how-to-treat-deep-and-fine-wrinkles'],
  ['dolgu-uygulamalari-yuzu-sisirir-ya-da-genisletir-mi', 'do-filler-applications-make-the-face-puffy-or-broader'],
  ['yaslanmaya-bagli-yuzde-meydana-gelen-degisimler', 'changes-in-the-face-due-to-aging'],
  ['10-adimda-parlak-bir-cilde-sahip-olmanin-ipuclari', 'tips-for-achieving-radiant-skin-in-10-steps'],
  ['kozmetik-islemlere-ne-zaman-ve-hangi-uygulama-ile-baslamaliyiz', 'when-and-which-cosmetic-procedures-should-we-start'],
];

const applicationDetailPairs = trApplicationDetails.map((item, index) => [item.id, enApplicationDetails[index]?.id]).filter(([, enId]) => enId);
const applicationCategoryPairs = trApplicationCategories.map((item, index) => [item.applicationid, enApplicationCategories[index]?.applicationid]).filter(([, enId]) => enId);
const mediaPairs = trMedia.map((item, index) => [item.mediaid, enMedia[index]?.mediaid]).filter(([, enId]) => enId);

const blogMap = buildTwoWayMap(blogPairs);
const applicationDetailMap = buildTwoWayMap(applicationDetailPairs);
const applicationCategoryMap = buildTwoWayMap(applicationCategoryPairs);
const mediaMap = buildTwoWayMap(mediaPairs);

export const getBlogAlternates = (blogId, language) => {
  if (!blogId) {
    return { trPath: null, enPath: null };
  }

  if (language === 'en') {
    const trId = blogMap.enToTr[blogId];
    return {
      trPath: trId ? `/blogs/${trId}` : null,
      enPath: `/en/blogs/${blogId}`,
    };
  }

  const enId = blogMap.trToEn[blogId];
  return {
    trPath: `/blogs/${blogId}`,
    enPath: enId ? `/en/blogs/${enId}` : null,
  };
};

export const getApplicationDetailAlternates = (detailId, language) => {
  if (!detailId) {
    return { trItem: null, enItem: null };
  }

  if (language === 'en') {
    const trId = applicationDetailMap.enToTr[detailId] || null;
    return {
      trItem: trId ? trApplicationDetails.find((item) => item.id === trId) || null : null,
      enItem: enApplicationDetails.find((item) => item.id === detailId) || null,
    };
  }

  const enId = applicationDetailMap.trToEn[detailId] || null;
  return {
    trItem: trApplicationDetails.find((item) => item.id === detailId) || null,
    enItem: enId ? enApplicationDetails.find((item) => item.id === enId) || null : null,
  };
};

export const getApplicationCategoryAlternates = (categoryId, language) => {
  if (!categoryId) {
    return { trId: null, enId: null };
  }

  if (language === 'en') {
    return {
      trId: applicationCategoryMap.enToTr[categoryId] || null,
      enId: categoryId,
    };
  }

  return {
    trId: categoryId,
    enId: applicationCategoryMap.trToEn[categoryId] || null,
  };
};

export const getMediaAlternates = (mediaId, language) => {
  if (!mediaId) {
    return { trId: null, enId: null };
  }

  if (language === 'en') {
    return {
      trId: mediaMap.enToTr[mediaId] || null,
      enId: mediaId,
    };
  }

  return {
    trId: mediaId,
    enId: mediaMap.trToEn[mediaId] || null,
  };
};
